/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ebr_Diff_Only_ChangesInputs */

const cs_ebr_diff_only_changes = /** @type {(inputs: Ebr_Diff_Only_ChangesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jen změny`)
};

const en_ebr_diff_only_changes = /** @type {(inputs: Ebr_Diff_Only_ChangesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Only changes`)
};

/**
* | output |
* | --- |
* | "Only changes" |
*
* @param {Ebr_Diff_Only_ChangesInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const ebr_diff_only_changes = /** @type {((inputs?: Ebr_Diff_Only_ChangesInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ebr_Diff_Only_ChangesInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ebr_diff_only_changes(inputs)
	return cs_ebr_diff_only_changes(inputs)
});